export var getContenidoTipoFuncionAbrirVisorFC = function getContenidoTipoFuncionAbrirVisorFC(state, zona) {
  var params = zona.vinculo.split(':')[1];
  var flashcards = 'swf,FLASHCARDS:' + params; // const contenido = {
  //     tipo: 'funcion,abrirEjercicioGG',
  //     src: `contenido/GG/ejercicio.html?&curso=curso&res=res&plantillaId=${plantillaId}&fcs=${fcs}`
  // }    

  var contenido = {
    tipo: 'flashcards',
    flashcards: flashcards // window.console.log("getContenidoTipoFuncionAbrirEjercicioGG zona, contenido", zona, contenido)

  };
  return contenido;
};